export default "__VITE_ASSET__BTnGRX$$__"